import React from 'react';
import './TvPlayer.scss';
import {
    faPlay, faVolumeUp, faPause, faVolumeMute, faExpand, faCompress,
    //faRotateBackward, faRotateForward,
    faBackward, faForward
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { pubPath } from 'Flow2/components/AdvancedBox/AdvancedHelpers/AppHelper';
import * as cTypes from 'Flow2/components/AdvancedBox/AdvancedConfig/AdvancedTypes';
import { strToHHMMSS, setBg } from 'Flow2/components/AdvancedBox/AdvancedHelpers/PlayerHelper';
import { getSubImg } from 'Flow2/components/AdvancedBox/AdvancedHelpers/FileHelper';
import { isSdk } from 'Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil';

class TvPlayer extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            paused: !this.props.isAuto,
            muted: false,
            length: null,
            formattedLength: null,
            currentTime: null,
            formattedTime: null,
            volume: 0.5,
            curSpeed: 1,
            src: ""
        };
    }

    curInterval;

    closeVideo = () => {
        const mainVideo = document.getElementById("tvvideo-id");
        mainVideo.pause();
        clearInterval(this.curInterval);
    }

    getPreviewUrl = () => {
        let clip = this.props.clip;
        let previewUrl;
        if (isSdk()) {
            if (clip && clip.mediafiles
                && clip.mediafiles.length) {
                clip.mediafiles.forEach(mfile => {
                    if (mfile.data && mfile.data.tags
                        && mfile.data.tags.includes(cTypes.PREVIEW) && !previewUrl) {
                        previewUrl = mfile.data.url;
                        if (previewUrl.startsWith("//")) {
                            previewUrl = "https:" + previewUrl;
                        }
                        console.log("LOGS: previewUrl", previewUrl);
                    }
                });
            }
        }
        this.setState({ src: previewUrl ? previewUrl : this.props.src });
    }

    initSpeedBox = () => {
        const mainVideo = document.getElementById("tvvideo-id");
        const speedBtn = document.querySelector('.tvplayback-speed span');
        const speedOptions = document.querySelector('.tvspeed-options');
        const speedOptionsItems = document.querySelectorAll('.tvspeed-options div');
        speedBtn.addEventListener('click', () => {
            speedOptions.classList.toggle('show');
        });
        speedOptionsItems.forEach((option) => {
            option.addEventListener('click', () => {
                mainVideo.playbackRate = option.dataset.speed;
                speedOptions.querySelector('.tvactive-option').classList.remove('tvactive-option');
                option.classList.add('tvactive-option');
                this.setState({ curSpeed: option.dataset.speed });
            })
        });
    }

    initVideo = () => {
        const mainVideo = document.getElementById("tvvideo-id");
        const progressBar = document.querySelector('.tvprogress-bar');
        //const progress = document.querySelector('.tvtime_range');

        mainVideo.addEventListener('timeupdate', (e) => {
            let { currentTime, duration } = e.target;
            let percent = (currentTime / duration) * 100;
            progressBar.style.width = `${percent}%`;
            //progress.style.background = setBg({ value: percent });
        });
        this.initSpeedBox();
    }

    play = () => {
        this.duration();
        const mainVideo = document.getElementById("tvvideo-id");
        this.setState({ paused: !this.state.paused });
        if (this.state.paused == true) {
            mainVideo.play();
            this.setState({ paused: false });
        } else {
            mainVideo.pause();
            this.setState({ paused: true });
        }
    }

    duration = () => {
        let dur = document.getElementById("tvvideo-id").duration;
        dur = dur.toFixed(2);
        let formattedLength = strToHHMMSS({ str: dur });
        this.setState({ length: dur, formattedLength: formattedLength });
        return dur;
    }

    currentTime = () => {
        let cur = document.getElementById("tvvideo-id").currentTime;
        cur = cur.toFixed(2);
        let formattedTime = strToHHMMSS({ str: cur });
        this.setState({ currentTime: cur, formattedTime: formattedTime });
        if (parseInt(this.state.currentTime) === parseInt(this.state.length)) {
            this.setState({ paused: !this.props.isAuto });
        }
        return cur;
    }

    customTime = () => {
        const time_range = document.querySelector(".tvtime_range");
        const videoEl = document.getElementById("tvvideo-id");
        if (time_range && time_range.value) {
            videoEl.currentTime = time_range.value;
            this.setState({ currentTime: time_range.value });
        }
    }


    customVolume = () => {
        const volume_range = document.querySelector(".tvvolume_range");
        document.getElementById("tvvideo-id").volume = volume_range.value;
        this.setState({ volume: volume_range.value });
        if (volume_range.value == 0) {
            this.setState({ muted: true });
        } else {
            this.setState({ muted: false });
        }
    }

    mute = () => {
        const mainVideo = document.getElementById("tvvideo-id");
        mainVideo.muted = true;
        this.setState({ muted: true });
        if (this.state.muted == true) {
            mainVideo.muted = false;
            this.setState({ muted: false });
        } else {
            mainVideo.muted = true;
            this.setState({ muted: true });
        }
    }

    onFullScreen = () => {
        const mainVideo = document.getElementById("tvvideo-id");
        mainVideo.requestFullscreen();
    }

    skipBackward = () => {
        const mainVideo = document.getElementById("tvvideo-id");
        mainVideo.currentTime -= 5;
    }

    skipForward = () => {
        const mainVideo = document.getElementById("tvvideo-id");
        mainVideo.currentTime += 5
    }

    onScrubEnd = () => { }

    showTimeBox = () => {
        return (
            <div>
                <span className="tvtime">
                    <span className="tvvideo_time">{this.state.formattedTime}</span>
                    <span> / </span>
                    <span className="tvvideo_length">{this.state.formattedLength}</span>
                </span>
            </div>
        )
    }

    showProgressBox = () => {
        return (
            <div className="tvcontrols-progress-box">
                <div className="tvcontrols-progress">
                    <input type="range" className="tvtime_range" onChange={this.customTime.bind(this)}
                        onMouseUp={this.onScrubEnd} onKeyUp={this.onScrubEnd}
                        value={this.state.currentTime} step={0.1} min={0} max={this.state.length} />
                    <div className="tvprogress-bar"></div>
                </div>
            </div>
        )
    }

    showSpeedBox = () => {
        return (
            <div className="tvplayback-content">
                <button className="tvplayback-speed">
                    <span className="tvplayback-rounded">
                        {this.state.curSpeed}
                    </span>
                </button>
                <div className="tvspeed-options">
                    {cTypes.SPEED_ITEMS.map((item, i) => {
                        return (<div data-speed={item.value} key={`tvpeed-options${i}`}
                            className={`${item.htmlClass && item.htmlClass}`}>{item.name}</div>)
                    })}
                </div>
            </div>
        )
    }

    showPlayBox = () => {
        return (
            <div>
                <button onClick={this.skipBackward} className="tvplay_pause_btn">
                    <span><FontAwesomeIcon icon={faBackward} /></span>
                </button>
                <button onClick={this.play.bind(this)} className="tvplay_pause_btn">
                    <span><FontAwesomeIcon icon={this.state.paused ? faPlay : faPause} /></span>
                </button>
                <button onClick={this.skipForward} className="tvplay_pause_btn">
                    <span><FontAwesomeIcon icon={faForward} /></span>
                </button>
            </div>
        )
    }

    showOtherBox = () => {
        return (
            <div className="tvactions-box">
                <input type="range" className="tvvolume_range"
                    onChange={this.customVolume.bind(this)}
                    value={this.state.volume} step={0.1} min={0} max={1} />
                {this.showSpeedBox()}
                {/* <div className="tvactions-box-icon">
                    <img src={getSubImg()} />
                </div> */}
                <button onClick={this.mute.bind(this)} className="tvmute_unmute_btn">
                    <span><FontAwesomeIcon icon={this.state.muted ? faVolumeMute : faVolumeUp} /></span>
                </button>
                <button className="tvfullscreen_btn" onClick={this.onFullScreen}>
                    <span><FontAwesomeIcon icon={this.state.isFull ? faCompress : faExpand} /></span>
                </button>
            </div>
        )
    }

    componentDidMount() {
        this.customVolume();
        this.initVideo();
        this.curInterval = setInterval(() => {
            this.setState({
                currentTime: this.currentTime(),
                length: this.duration()
            })
        }, cTypes.PLAYER_INTERVAL_TIME);

        this.getPreviewUrl();
        console.log("LOGS: TVPlayer this.props.clip", this.props.clip);
    }

    componentWillUnmount() {
        this.closeVideo();
    }

    render() {
        return (
            <div className="tvplayer-container">
                <div className="tvplayer">
                    <video id="tvvideo-id" width="500" height="auto" poster={this.props.poster}
                        autoPlay={this.props.isAuto} loop={this.props.isLoop}>
                        <source src={this.state.src} type="video/mp4" />
                    </video>

                    <div className="tvcontrols-progress-wrapper">
                        {this.showProgressBox()}
                    </div>
                    <div className="tvcontrols">
                        <div className="tvcontrols-box">
                            <div></div>
                            {this.showTimeBox()}
                        </div>
                        {this.showPlayBox()}
                        {this.showOtherBox()}
                    </div>
                </div>
            </div>
        );
    }
}

export default TvPlayer;

